var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHaiti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.4541C32 25.2906 24.8365 32.4541 16 32.4541C7.1635 32.4541 0 25.2906 0 16.4541C0 7.6176 16 0.454102 16 0.454102C16 0.454102 32 7.6176 32 16.4541Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.4541C0 7.6176 7.1635 0.454102 16 0.454102C24.8365 0.454102 32 7.6176 32 16.4541",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 20.6282L16 19.9326L10.4348 20.6282V12.2803H21.5652V20.6282Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 19.932C17.5367 19.932 18.7825 18.6862 18.7825 17.1494C18.7825 15.6126 17.5367 14.3667 15.9999 14.3667C14.4631 14.3667 13.2173 15.6126 13.2173 17.1494C13.2173 18.6862 14.4631 19.932 15.9999 19.932Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18.5409C16.7684 18.5409 17.3913 17.918 17.3913 17.1496C17.3913 16.3812 16.7684 15.7583 16 15.7583C15.2316 15.7583 14.6086 16.3812 14.6086 17.1496C14.6086 17.918 15.2316 18.5409 16 18.5409Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9132 13.6719H18.0871L16.0002 15.7589L13.9132 13.6719Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3042 15.0625H16.6955V19.2365H15.3042V15.0625Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2261 18.8195H13.7738L10.4348 20.6282H21.5652L18.2261 18.8195Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.454102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaiti);
export default __webpack_public_path__ + "static/media/haiti.90b64afd.svg";
export { ForwardRef as ReactComponent };